import { router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Heart, ArrowLeft } from 'lucide-react'

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-50 border-b bg-white/80 backdrop-blur-sm dark:bg-gray-950/80 dark:border-gray-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-indigo-600">
                <Heart className="h-6 w-6 text-white" />
              </div>
              <span className="text-xl font-semibold">Breakthrough Health</span>
            </div>
            <Button variant="ghost" onClick={() => router.visit('/')}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </div>
        </div>
      </nav>

      {/* Content Section */}
      <section className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-6">
            Medical Disclaimer
          </h1>
          <div className="h-1 w-24 mx-auto bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-full"></div>
        </div>

        <div className="prose prose-lg dark:prose-invert max-w-none">
          <div className="space-y-6 text-lg leading-relaxed text-foreground">
            <div className="p-6 bg-yellow-50 dark:bg-yellow-950/30 border-l-4 border-yellow-600 rounded-r-lg">
              <p className="font-semibold mb-2">Important Notice</p>
              <p>
                The information provided on this platform is for informational purposes only and is not intended to be a substitute for professional medical advice, diagnosis, or treatment.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold mb-4">Not Medical Advice</h2>
              <p className="mb-4">
                This platform is designed to facilitate care coordination and management for healthcare providers treating Hepatitis C patients. It is not intended to provide medical advice directly to patients.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Professional Consultation Required</h2>
              <p className="mb-4">
                Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on this platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Emergency Situations</h2>
              <p className="mb-4">
                If you think you may have a medical emergency, call your doctor, go to the emergency department, or call 911 immediately.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">No Warranty</h2>
              <p className="mb-4">
                Breakthrough Health does not recommend or endorse any specific tests, physicians, products, procedures, opinions, or other information that may be mentioned on the platform. Reliance on any information provided by Breakthrough Health is solely at your own risk.
              </p>
            </section>

            <section className="mt-8 p-6 bg-blue-50 dark:bg-blue-950/30 rounded-lg">
              <p className="text-sm text-muted-foreground">
                Last updated: January 2025
              </p>
            </section>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <Button size="lg" onClick={() => router.visit('/')}>
            Back to Home
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t bg-white/50 backdrop-blur-sm dark:bg-gray-950/50 dark:border-gray-800 mt-20">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center gap-4 text-center text-sm text-muted-foreground md:flex-row md:justify-between">
            <p>&copy; 2026 Breakthrough Health. Empowering community health through technology.</p>
            <div className="flex gap-6">
              <button
                onClick={() => router.visit('/about')}
                className="hover:text-foreground transition-colors"
              >
                About Us
              </button>
              <button
                onClick={() => router.visit('/disclaimer')}
                className="hover:text-foreground transition-colors"
              >
                Disclaimer
              </button>
              <button
                onClick={() => router.visit('/privacy')}
                className="hover:text-foreground transition-colors"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
